function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "m207.736 247.241-3.624-76.348a14.979 14.979 0 0 0 -4.682-10.06 29.918 29.918 0 0 0 -6.43 12.667c-4.247 17.838-26.533 18.359-33.147 18.112-.04 0-.077.008-.116.007a34.467 34.467 0 0 1 -10.188 40.381 6.337 6.337 0 0 1 -2.513 1.209 84.163 84.163 0 0 1 -38.076 0 6.315 6.315 0 0 1 -2.506-1.2 34.421 34.421 0 0 1 -12.854-29.252 33.9 33.9 0 0 1 2.679-11.137c-.044 0-.087-.01-.131-.008-6.614.247-28.9-.274-33.147-18.112a29.918 29.918 0 0 0 -6.43-12.667 14.979 14.979 0 0 0 -4.682 10.06l-3.624 76.348a5.928 5.928 0 0 0 5.919 6.259h147.633a5.928 5.928 0 0 0 5.919-6.259z",
  fill: "#57af12"
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  fill: "#fcdd86",
  height: 9,
  rx: 4.5,
  width: 62.636,
  x: 96.682,
  y: 244.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m154.01 244.5-6.234-11.517a6.506 6.506 0 0 1 -.74.224 84.163 84.163 0 0 1 -38.076 0 6.639 6.639 0 0 1 -.736-.222l-6.234 11.515z",
  fill: "#f5c84c"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m125.554 170.7a34.475 34.475 0 0 0 -19.1 61.3 6.315 6.315 0 0 0 2.506 1.2 84.163 84.163 0 0 0 38.076 0 6.337 6.337 0 0 0 2.513-1.2 34.476 34.476 0 0 0 -24-61.3z",
  fill: "#edf4fc"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m96.147 191.612c.044 0 .087.008.131.008a34.873 34.873 0 0 1 15.6-16.983 79.4 79.4 0 0 1 -37.118-20.365s-17.592-12.614-35.458-7.4a1.453 1.453 0 0 0 -.042 2.774c6.893 2.275 20.096 8.554 23.74 23.854 4.247 17.838 26.533 18.359 33.147 18.112z",
  fill: "#87d147"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m216.7 146.868c-17.866-5.21-36.255 7.2-36.255 7.2a79.623 79.623 0 0 1 -36.61 20.4 34.594 34.594 0 0 1 15.9 17.151c.039 0 .076-.009.116-.007 6.614.247 28.9-.274 33.147-18.112 3.644-15.3 16.847-21.579 23.742-23.858a1.453 1.453 0 0 0 -.04-2.774z",
  fill: "#87d147"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m197.035 135.266a16.58 16.58 0 0 1 -4.885 1.441 17.7 17.7 0 0 1 -19.788-15.316c-2.755-22.588 32.862-50.728 9.09-89.628-24.617-40.282-57.887-26.718-66.761-22.105a8.656 8.656 0 0 1 -4.636.948c-32.724-2.431-43.045 29.677-41.887 56.314 1.3 29.948 24.74 57.293 13.021 67.71-7.989 7.1-15.978 5.125-20.254 3.148a1.131 1.131 0 0 0 -1.457 1.6c7.753 13.069 25.318 17.69 37.336 5.671 13.022-13.021 0-32.552-7.812-66.407-6.072-26.312 11.452-43.186 19.562-49.4a2.886 2.886 0 0 1 4.511 1.5c4.1 13.359 27.2 22.818 44.939 32.277 19.531 10.417 1.3 42.97 1.3 42.97s-15.626 31.251 7.812 44.272c.664.369 1.318.678 1.966.959l5.938 1.5c10.642.683 18.642-9.493 23.317-15.821a1.078 1.078 0 0 0 -1.312-1.633z",
  fill: "#fc8c48"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m155.406 117.417a56.03 56.03 0 0 1 3.91-11.434s18.229-32.553-1.3-42.97c-17.736-9.459-40.841-18.918-44.939-32.277a2.886 2.886 0 0 0 -4.511-1.5c-8.112 6.217-25.636 23.091-19.566 49.403 3.752 16.257 8.7 29.205 11.391 39.721 7.36 7.355 16.8 11.791 27.054 11.791 10.687 0 20.476-4.822 27.961-12.734z",
  fill: "#f9d0b4"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m125.554 170.7a34.414 34.414 0 0 1 18.281 3.772 79.623 79.623 0 0 0 36.61-20.4l-14.117-3.553a29.611 29.611 0 0 1 -5.881-2.163l-11.933-5.883a5.381 5.381 0 0 1 -3-4.825v-12.4a36.236 36.236 0 0 1 -18.066 4.905 36.1 36.1 0 0 1 -16.96-4.291v11.787a5.381 5.381 0 0 1 -3 4.825l-11.933 5.884a29.671 29.671 0 0 1 -5.881 2.162l-14.914 3.754a79.4 79.4 0 0 0 37.118 20.365 33.989 33.989 0 0 1 13.676-3.939z",
  fill: "#f9d0b4"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 145.025,
  cy: 78.4,
  fill: "#c7d7e5",
  r: 5.225
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 110.975,
  cy: 78.4,
  fill: "#c7d7e5",
  r: 5.225
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m127.444 103.87a33.017 33.017 0 0 1 -12.306-2.368c3.7 6.875 7.879 10.781 12.3 10.781 4.422 0 8.6-3.911 12.292-10.78a32.979 32.979 0 0 1 -12.286 2.367z",
  fill: "#fc657e"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m53.372 25.6h-2.266v-2.27a3.071 3.071 0 0 0 -6.142 0v2.27h-2.264a3.071 3.071 0 0 0 0 6.142h2.265v2.258a3.071 3.071 0 0 0 6.142 0v-2.262h2.266a3.071 3.071 0 0 0 0-6.142z",
  fill: "#87d147"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m207.857 107.64a10.8 10.8 0 0 1 -8.654-8.479.2.2 0 0 0 -.384 0 10.8 10.8 0 0 1 -8.654 8.479.19.19 0 0 0 0 .376 10.794 10.794 0 0 1 8.654 8.478.2.2 0 0 0 .384 0 10.8 10.8 0 0 1 8.654-8.478.19.19 0 0 0 0-.376z",
  fill: "#70d6f9"
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  cx: 69.019,
  cy: 3.285,
  fill: "#f5c84c",
  r: 3.285
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  cx: 221.019,
  cy: 125.285,
  fill: "#87d147",
  r: 3.285
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  cx: 136.019,
  cy: 182.285,
  r: 3.285
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  cx: 27.019,
  cy: 229.285,
  fill: "#ef4460",
  r: 3.285
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "m76 255.347a2.5 2.5 0 0 1 -2.5-2.5v-47.447a2.5 2.5 0 0 1 5 0v47.45a2.5 2.5 0 0 1 -2.5 2.497z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "m180 255.347a2.5 2.5 0 0 1 -2.5-2.5v-47.447a2.5 2.5 0 0 1 5 0v47.45a2.5 2.5 0 0 1 -2.5 2.497z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "m176.065 155.242q-.591 0-1.194-.038a2.525 2.525 0 0 1 -.45-.071l-5.938-1.494a2.536 2.536 0 0 1 -.385-.132 24.139 24.139 0 0 1 -2.184-1.067c-20.194-11.219-14.609-36.025-8.835-47.575.018-.034.036-.069.055-.1.1-.185 10.283-18.627 6.625-31.084a13.47 13.47 0 0 0 -6.922-8.459c-2.947-1.573-5.985-3.115-9.2-4.748-16.335-8.291-33.226-16.866-36.949-29a.44.44 0 0 0 -.286-.3.319.319 0 0 0 -.317.058c-7.527 5.759-24.411 21.868-18.647 46.845 2.226 9.645 4.89 18.154 7.242 25.662 5.949 19 10.248 32.73-.1 43.075a24.867 24.867 0 0 1 -20.987 7.5 28.006 28.006 0 0 1 -20.265-13.664 3.631 3.631 0 0 1 4.656-5.141c4.337 2.005 10.9 3.158 17.544-2.748 5.173-4.6 1.226-14.733-3.772-27.564-4.445-11.413-9.485-24.348-10.086-38.168-.895-20.577 4.845-38.946 15.352-49.135 7.6-7.367 17.428-10.658 29.218-9.781a6.139 6.139 0 0 0 3.3-.673c5.256-2.732 15.987-7.152 28.842-6.056 16.407 1.4 30.27 11.183 41.2 29.075 15.937 26.077 6.207 47.812-1.611 65.276-4.311 9.629-8.033 17.945-7.129 25.354a15.195 15.195 0 0 0 16.968 13.141 14.074 14.074 0 0 0 4.15-1.222 3.578 3.578 0 0 1 4.4 5.366c-4.091 5.537-12.46 16.867-24.295 16.868zm-.655-5.015c7.113.332 13.1-5.011 18.147-11.219-.353.068-.708.126-1.068.175a20.2 20.2 0 0 1 -22.608-17.489c-1.072-8.788 3.1-18.121 7.528-28 7.721-17.247 16.472-36.8 1.909-60.626-5.9-9.647-27.9-39.688-63.473-21.19a11.146 11.146 0 0 1 -5.976 1.223c-10.3-.766-18.84 2.055-25.366 8.384-9.5 9.211-14.671 26.156-13.837 45.329.564 12.993 5.444 25.519 9.749 36.57 5.478 14.062 10.208 26.207 2.436 33.116-6.878 6.112-13.789 6.251-18.767 5.026a22.519 22.519 0 0 0 14.134 7.827 19.985 19.985 0 0 0 16.829-6.072c8.2-8.2 4.487-20.076-1.139-38.046-2.378-7.593-5.073-16.2-7.342-26.032-6.418-27.811 12.182-45.593 20.477-51.947a5.348 5.348 0 0 1 4.882-.85 5.448 5.448 0 0 1 3.54 3.6c3.1 10.106 19.747 18.556 34.432 26.011 3.1 1.572 6.3 3.2 9.293 4.794a18.484 18.484 0 0 1 9.369 11.473c4.173 14.234-6.237 33.434-7.03 34.865-.848 1.724-14.02 29.349 6.814 40.923.473.264.974.511 1.563.772z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "m127.447 132.651c-10.5 0-20.74-4.447-28.821-12.522a2.5 2.5 0 0 1 -.655-1.149c-1.064-4.151-2.522-8.812-4.067-13.747-2.376-7.592-5.068-16.2-7.338-26.032-6.418-27.809 12.182-45.591 20.477-51.945a5.348 5.348 0 0 1 4.882-.85 5.448 5.448 0 0 1 3.54 3.6c3.1 10.106 19.747 18.556 34.432 26.011 3.1 1.572 6.3 3.2 9.293 4.794a18.484 18.484 0 0 1 9.369 11.473c4.169 14.219-6.215 33.4-7.028 34.861a54.681 54.681 0 0 0 -3.688 10.83 2.5 2.5 0 0 1 -.621 1.164c-8.245 8.713-18.822 13.512-29.775 13.512zm-24.808-15.588c7.058 6.833 15.843 10.588 24.808 10.588 9.366 0 18.461-4.068 25.68-11.471a57.991 57.991 0 0 1 3.952-11.315c.018-.034.036-.069.055-.1.1-.185 10.283-18.627 6.625-31.084a13.47 13.47 0 0 0 -6.922-8.459c-2.947-1.573-5.985-3.115-9.2-4.748-16.335-8.291-33.226-16.866-36.949-29a.44.44 0 0 0 -.286-.3.319.319 0 0 0 -.317.058c-7.527 5.759-24.411 21.868-18.647 46.845 2.226 9.648 4.889 18.156 7.239 25.663 1.482 4.737 2.886 9.225 3.962 13.323z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "m127.447 155.651a39.71 39.71 0 0 1 -24.761-8.906 2.5 2.5 0 1 1 3.1-3.922 33.883 33.883 0 0 0 43.606-.239 2.5 2.5 0 0 1 3.138 3.893 39.744 39.744 0 0 1 -25.083 9.174z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "m138.5 165a2.5 2.5 0 0 1 -2.5-2.5v-10a2.5 2.5 0 0 1 5 0v10a2.5 2.5 0 0 1 -2.5 2.5z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "m150.646 159.671a2.488 2.488 0 0 1 -1.352-.4l-8.633-5.558a2.5 2.5 0 0 1 2.707-4.2l8.632 5.555a2.5 2.5 0 0 1 -1.355 4.6z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "m127.444 106.37a35.525 35.525 0 0 1 -16.176-3.873 2.5 2.5 0 0 1 2.285-4.448 30.683 30.683 0 0 0 27.768 0 2.5 2.5 0 1 1 2.285 4.448 35.495 35.495 0 0 1 -16.162 3.873z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "m149.534 78.269a2.5 2.5 0 0 1 -1.607-4.416l3.092-2.594a2.5 2.5 0 0 1 3.212 3.831l-3.091 2.594a2.488 2.488 0 0 1 -1.606.585z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "m138.377 86.125a2.5 2.5 0 0 1 -1.516-4.49l2.575-1.958a2.5 2.5 0 0 1 3.027 3.979l-2.574 1.959a2.49 2.49 0 0 1 -1.512.51z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "m106.466 78.269a2.488 2.488 0 0 1 -1.606-.585l-3.091-2.594a2.5 2.5 0 0 1 3.212-3.831l3.092 2.594a2.5 2.5 0 0 1 -1.607 4.416z"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "m117.623 86.125a2.49 2.49 0 0 1 -1.512-.51l-2.574-1.959a2.5 2.5 0 0 1 3.027-3.979l2.575 1.958a2.5 2.5 0 0 1 -1.516 4.49z"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "m94.178 194.148c-8.867 0-29.312-2.016-33.61-20.069-3.319-13.94-15.267-19.807-22.094-22.063a3.953 3.953 0 0 1 .127-7.548c18.822-5.487 36.855 7.228 37.614 7.772a2.642 2.642 0 0 1 .265.22 77.228 77.228 0 0 0 35.946 19.74 2.5 2.5 0 0 1 .627 4.644 32.4 32.4 0 0 0 -14.478 15.756 2.5 2.5 0 0 1 -2.3 1.516c-.044 0-.1 0-.161 0-.555.018-1.207.032-1.936.032zm-50.807-45.641c7.9 3.276 18.687 10.242 22.061 24.414 3.548 14.9 21.8 16.3 29.225 16.225a37.436 37.436 0 0 1 11.106-13.555 83.52 83.52 0 0 1 -32.587-19.374c-1.458-.995-15.276-10.076-29.805-7.71z"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "m161.822 194.148c-.727 0-1.375-.014-1.931-.033-.062 0-.124 0-.186 0a2.5 2.5 0 0 1 -2.269-1.522 32.108 32.108 0 0 0 -14.751-15.909 2.5 2.5 0 0 1 .575-4.653 77.465 77.465 0 0 0 35.456-19.77 2.479 2.479 0 0 1 .33-.266c.79-.533 19.575-13.007 38.354-7.531a3.953 3.953 0 0 1 .126 7.548c-6.827 2.256-18.775 8.123-22.094 22.063-4.298 18.055-24.742 20.072-33.61 20.073zm-.46-5c7.474.055 25.659-1.334 29.206-16.225 3.374-14.173 14.165-21.14 22.063-24.415-14.569-2.391-28.946 6.456-30.628 7.533a83.742 83.742 0 0 1 -32.034 19.317 37.142 37.142 0 0 1 11.393 13.788z"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "m201.816 256h-147.632a8.429 8.429 0 0 1 -8.416-8.9l3.624-76.328a17.437 17.437 0 0 1 5.461-11.757 2.476 2.476 0 0 1 1.851-.681 2.5 2.5 0 0 1 1.768.874 32.535 32.535 0 0 1 6.96 13.711c3.8 15.947 24.407 16.422 30.622 16.193a3.466 3.466 0 0 1 .362.01 2.5 2.5 0 0 1 2.159 3.48 31.389 31.389 0 0 0 -2.481 10.317 32.081 32.081 0 0 0 11.924 27.129 3.832 3.832 0 0 0 1.516.723 81.668 81.668 0 0 0 36.927 0 3.847 3.847 0 0 0 1.523-.726 31.966 31.966 0 0 0 9.452-37.451 2.571 2.571 0 0 1 2.51-3.483c6.224.234 26.825-.247 30.622-16.193a32.535 32.535 0 0 1 6.96-13.711 2.5 2.5 0 0 1 3.619-.193 17.426 17.426 0 0 1 5.46 11.737l3.626 76.362a8.429 8.429 0 0 1 -8.417 8.887zm-145.348-91.2a12.409 12.409 0 0 0 -2.083 6.231l-3.624 76.329a3.429 3.429 0 0 0 3.423 3.64h147.632a3.429 3.429 0 0 0 3.424-3.62v-.02l-3.625-76.348a12.388 12.388 0 0 0 -2.081-6.211 27.56 27.56 0 0 0 -4.1 9.278c-4.071 17.1-22.629 19.811-32.114 20.05a36.978 36.978 0 0 1 -12.206 39.82 8.892 8.892 0 0 1 -3.5 1.691 86.663 86.663 0 0 1 -39.226 0 8.876 8.876 0 0 1 -3.494-1.688 37.088 37.088 0 0 1 -13.786-31.359 36.143 36.143 0 0 1 1.583-8.463c-9.474-.236-28.046-2.942-32.12-20.05a27.577 27.577 0 0 0 -4.103-9.28z"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "m111.876 177.137a2.5 2.5 0 0 1 -.55-.061 82.24 82.24 0 0 1 -38.291-20.992 2.5 2.5 0 0 1 1.112-4.236l14.915-3.754a27.293 27.293 0 0 0 5.386-1.981l11.933-5.883a2.864 2.864 0 0 0 1.605-2.584v-11.786a2.5 2.5 0 0 1 3.669-2.21 33.2 33.2 0 0 0 32.618-.575 2.5 2.5 0 0 1 3.741 2.171v12.4a2.861 2.861 0 0 0 1.6 2.583l11.933 5.884a27.293 27.293 0 0 0 5.386 1.981l14.117 3.553a2.5 2.5 0 0 1 1.118 4.23 82.461 82.461 0 0 1 -37.758 21.023 2.5 2.5 0 0 1 -1.725-.213 32.074 32.074 0 0 0 -16.958-3.5 31.36 31.36 0 0 0 -12.674 3.652 2.5 2.5 0 0 1 -1.177.298zm-31.963-21.585a76.4 76.4 0 0 0 31.632 16.441 36.258 36.258 0 0 1 13.838-3.791 37.079 37.079 0 0 1 18.753 3.62 76.667 76.667 0 0 0 31.172-16.466l-9.59-2.414a32.239 32.239 0 0 1 -6.377-2.344l-11.933-5.884a7.831 7.831 0 0 1 -4.394-7.068v-8.332a37.966 37.966 0 0 1 -30.028.474v7.858a7.831 7.831 0 0 1 -4.393 7.068l-11.934 5.886a32.239 32.239 0 0 1 -6.377 2.344z"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "m153.506 210.069a2.5 2.5 0 0 1 -2.5-2.5 25.768 25.768 0 0 0 -8.231-18.988 2.5 2.5 0 1 1 3.42-3.648 31.135 31.135 0 0 1 9.811 22.636 2.5 2.5 0 0 1 -2.5 2.5z"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "m145.025 86.125a7.725 7.725 0 1 1 7.725-7.725 7.734 7.734 0 0 1 -7.725 7.725zm0-10.45a2.725 2.725 0 1 0 2.725 2.725 2.728 2.728 0 0 0 -2.725-2.725z"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "m110.975 86.125a7.725 7.725 0 1 1 7.725-7.725 7.733 7.733 0 0 1 -7.725 7.725zm0-10.45a2.725 2.725 0 1 0 2.725 2.725 2.728 2.728 0 0 0 -2.725-2.725z"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "m127.443 114.783c-5.311 0-10.191-4.07-14.506-12.1a2.5 2.5 0 0 1 3.132-3.5 30.632 30.632 0 0 0 22.736 0 2.5 2.5 0 0 1 3.133 3.5c-4.316 8.03-9.192 12.1-14.495 12.1zm-6.527-9.011c1.9 2.289 4.129 4.011 6.527 4.011s4.617-1.722 6.516-4.01a35.985 35.985 0 0 1 -13.043-.001z"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "m154.818 256h-53.636a7 7 0 0 1 0-14h53.636a7 7 0 0 1 0 14zm-53.636-9a2 2 0 0 0 0 4h53.636a2 2 0 0 0 0-4z"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "m154.01 247h-52.02a2.5 2.5 0 0 1 -2.2-3.69l6.233-11.517a2.5 2.5 0 0 1 3.05-1.16 3.893 3.893 0 0 0 .458.139 81.653 81.653 0 0 0 36.928 0 4.138 4.138 0 0 0 .463-.141 2.5 2.5 0 0 1 3.051 1.16l6.233 11.517a2.5 2.5 0 0 1 -2.2 3.69zm-47.823-5h43.626l-3.3-6.107a87.222 87.222 0 0 1 -37.017 0z"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "m128 237.888a85.382 85.382 0 0 1 -19.615-2.249 8.876 8.876 0 0 1 -3.494-1.688 36.974 36.974 0 0 1 20.492-65.751 36.694 36.694 0 0 1 27.843 9.85 36.972 36.972 0 0 1 -2.114 55.9 8.892 8.892 0 0 1 -3.5 1.691 85.328 85.328 0 0 1 -19.612 2.247zm-2.273-64.7a31.975 31.975 0 0 0 -17.709 56.86 3.832 3.832 0 0 0 1.516.723 81.668 81.668 0 0 0 36.927 0 3.847 3.847 0 0 0 1.523-.726 31.977 31.977 0 0 0 -22.257-56.858z"
});

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: 512,
  viewBox: "0 0 256 256",
  width: 512
}, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41);

export default __webpack_public_path__ + "static/media/voyante.dce90f57.svg";
export { SvgComponent as ReactComponent };